import Swal from "sweetalert2";

export async function deletePaperPopup(item) {
  const result = await base({
    title: `삭제하시겠습니까?`,
    confirmButtonText: "네",
    cancelButtonText: "취소하기",
    icon: "warning",
  });
  if (result.isConfirmed) {
    return true;
  }
  return false;
}

export async function closePopup() {
  const result = await base({
    title: "나가시겠습니까? 저장하지 않은 정보는 삭제됩니다.",
    confirmButtonText: "네",
    cancelButtonText: "취소하기",
    icon: "warning",
  });
  if (result.isConfirmed) {
    return true;
  }
  return false;
}

export async function deletePopup() {
  const result = await base({
    title: "삭제하시겠습니까?",
    confirmButtonText: "네",
    cancelButtonText: "취소하기",
    icon: "warning",
  });
  if (result.isConfirmed) {
    return true;
  }
  return false;
}

export async function savePopup() {
  const result = await base({
    title: "저장하시겠습니까?",
    confirmButtonText: "네",
    cancelButtonText: "취소하기",
    icon: "warning",
  });
  if (result.isConfirmed) {
    return true;
  }
  return false;
}

export async function submitPopup() {
  const result = await base({
    title: "제출 하시겠습니까? 모든 정보를 확인하십시오.",
    confirmButtonText: "네",
    cancelButtonText: "취소하기",
    icon: "warning",
  });
  if (result.isConfirmed) {
    return true;
  }
  return false;
}

function base(descriptions) {
  return Swal.fire({
    title: descriptions.title,
    html: descriptions.html,
    confirmButtonText: descriptions.confirmButtonText,
    cancelButtonText: descriptions.cancelButtonText,
    icon: descriptions.icon,
    showCancelButton: true,
    confirmButtonClass: "md-button md-warning btn-fill",
    cancelButtonClass: "md-button md-danger btn-fill",
    confirmButtonColor: "orange",
    buttonsStyling: true,
    preConfirm: descriptions.preConfirm
  });
}

export function success() {
  return Swal.fire({
    title: "완료하였습니다",
    icon: "success",
    iconColor: "orange",
    confirmButtonClass: "md-button md-success btn-fill",
    confirmButtonColor: "orange",
    buttonsStyling: true,
  });
}
